var THF = THF || {};
THF.Interface = THF.Interface || {};

(function($, jQuery) {
	'use strict';

	THF.Interface.LeftNav = function( options ) {

		var defaults = {

			selectors: {
				parentElem: '.left-nav.mobile',
				accordionTrigger: '.accordion-trigger',
				childLinks: '.children'
			},
		};

		options = $.extend(true, {}, defaults, options );


		/**********************************
		// Declare variables
		**********************************/
		var parentElem = $(options.selectors.parentElem);
		var accordionTrigger = $parentElem(options.selectors.accordionTrigger);
		var childLinks = $parentElem(options.selectors.childLinks);

		/**********************************
		// Helper function to return a jQuery object, which is a child of 'parentElem'
		**********************************/
		function $parentElem( selector ) {
			return $(options.selectors.parentElem+' '+selector);
		}


		/**********************************
		// Interface events
		**********************************/
		function toggleSubNav(){
			parentElem.toggleClass('expanded');
		}


		/**********************************
		// Event binding
		**********************************/
		function bindEvents(){

			accordionTrigger.click(function(e){
				toggleSubNav();
				e.preventDefault();
			});
		}

		/**********************************
		// Simple constructor
		**********************************/
		function __construct() {
			// Init
			if (parentElem.length > 0){

				if(childLinks.length > 0){
					accordionTrigger.css('display','block');
					bindEvents();
				}

			}
		}

		__construct();

		//
		// Make some events accessible from global scope
		//
		return {
		};
	};


})(jQuery, jQuery);
